import { useMutation, UseMutationResult } from '@tanstack/react-query';
import {
  updateRefuelingContract,
  uploadRefuelingAttachment,
  deleteRefuelingAttachment,
} from '../../api/refueling-contract.ts';
import type {
  UpdateRefuelingContractRequest,
  UploadRefuelingContractAttachmentRequest,
  DeleteRefuelingContractAttachmentRequest,
} from '../../api/requests/refueling-contract-request.ts';

async function updateAll(
  updateRequest?: UpdateRefuelingContractRequest,
  uploadRequest?: UploadRefuelingContractAttachmentRequest,
  deleteRequest?: DeleteRefuelingContractAttachmentRequest,
) {
  const promises = [];
  if (updateRequest) {
    promises.push(updateRefuelingContract(updateRequest));
  }
  if (uploadRequest) {
    promises.push(uploadRefuelingAttachment(uploadRequest));
  }
  if (deleteRequest) {
    promises.push(deleteRefuelingAttachment(deleteRequest));
  }
  await Promise.all(promises);
}

export default function useUpdatePartner(): UseMutationResult<
  void,
  Error,
  [
    UpdateRefuelingContractRequest | null,
    UploadRefuelingContractAttachmentRequest | null,
    DeleteRefuelingContractAttachmentRequest | null,
  ]
> {
  return useMutation({
    mutationFn: ([updateRequest, uploadRequest, deleteRequest]) =>
      updateAll(updateRequest, uploadRequest, deleteRequest),
  });
}
